<template>
  <div>
    <div id="app">
      <div class="container">
        <router-view />
      </div>
    </div>

    <div id="footerBg">
      <div id="footer" :class="isHkom ? 'green' : ''">
        <div id="footer-itms">
          <div
            id="footer-btn-oodloziscu"
            class="footer-itm"
            @click="redirectContent('/vsebina/sovd')"
          >
            <div class="img"></div>
            <div class="txt">
              <i18n path="footer.firstElement.part1" tag="p">
                <b>{{ $t("footer.firstElement.part2") }}</b>
              </i18n>
            </div>
            <div class="btn">{{ $t("footer.firstButton") }}</div>
          </div>
          <div
            id="footer-btn-navodilazauporabo"
            class="footer-itm"
            @click="redirectContent('/vsebina/navodila')"
          >
            <div class="img"></div>
            <div class="txt">
              <i18n path="footer.secondElement.part1" tag="p">
                <br />
                <b>{{ $t("footer.secondElement.part2") }}</b>
              </i18n>
            </div>
            <div class="btn">{{ $t("footer.secondButton") }}</div>
          </div>
          <div
            id="footer-btn-pravnoobvestilo"
            class="footer-itm"
            @click="redirectContent('/vsebina/pravno-obvestilo')"
          >
            <div class="img"></div>
            <div class="txt">
              <i18n path="footer.thirdElement.part1" tag="p">
                <b>{{ $t("footer.thirdElement.part2") }}</b>
              </i18n>
            </div>
            <div class="btn">{{ $t("footer.thirdButton") }}</div>
          </div>
          <div
            v-if="isHkom"
            id="footer-btn-registracija"
            class="footer-itm"
            @click="redirectContent('/vsebina/registracija')"
          >
            <div class="img"></div>
            <div class="txt">
              <i18n path="footer.fourthElement.part1" tag="p">
                <br />
                <b>{{ $t("footer.fourthElement.part2") }}</b>
              </i18n>
            </div>
            <div class="btn">{{ $t("footer.fourthButton") }}</div>
          </div>
          <div
            v-else
            id="footer-btn-zgodovinaprenosov"
            class="footer-itm"
            @click="redirectContent('/zgodovina-prenosov')"
          >
            <div class="img"></div>
            <div class="txt">
              <i18n path="footer.fifthElement.part1" tag="p">
                <br />
                <b>{{ $t("footer.fifthElement.part2") }}</b>
              </i18n>
            </div>
            <div class="btn">{{ $t("footer.fifthButton") }}</div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div id="footer-links">
          <a href="/">{{ $t("footer.links.onlineRepository") }}</a>
          <span class="spacer"></span>
          <a href="/vsebina/sovd">{{ $t("footer.links.aboutRepository") }}</a>
          <span class="spacer"></span>
          <a href="/vsebina/navodila">{{ $t("footer.links.userManual") }}</a>
          <span class="spacer"></span>
          <a href="/vsebina/pravno-obvestilo">{{ $t("footer.links.legal") }}</a>
          <span class="spacer"></span>
          <span v-if="isHkom">
            <a
              :href="`https://${secureBaseUrl}/`"
              :title="$t('footer.links.loginTitle')"
              >{{ $t("footer.links.login") }}</a
            >
          </span>
          <span v-else>
            <a href="/admin/statistike">{{ $t("footer.links.administration") }}</a>
            <span class="spacer"></span>
            <a href="/logout">{{ $t("footer.links.logout") }}</a>
          </span>
        </div>
        <div id="footer-txt">
          <p v-html="footerText"></p>
        </div>
        <div id="footer-logo">
          <a id="logo1" href="http://www.eu-skladi.si/" target="_blank">
            <img
              :src="eu_logo_path"
              alt="http://www.eu-skladi.si/"
              @mouseover="onMouseOver('eu')"
              @mouseout="onMouseOut('eu')"
            />
          </a>
          <img src="@/assets/img/footer-logo-spacer.png" alt="spacer" />
          <a id="logo2" href="http://nio.gov.si/nio/" target="_blank">
            <img
              :src="nio_logo_path"
              alt="http://nio.gov.si/nio/"
              @mouseover="onMouseOver('nio')"
              @mouseout="onMouseOut('nio')"
            />
          </a>
        </div>
        <div id="footer-copyright">
          <div>&#169; {{ $t("footer.footerText") }} {{ appVersion }}.</div>
          <br />
          <div>
            <a id="logo3" href="http://koofr.si/" target="_blank"
              ><img
                :src="koofr_logo_path"
                alt="koofr-logo"
                @mouseover="onMouseOver('koofr')"
                @mouseout="onMouseOut('koofr')"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setDocumentLanguage } from "./i18n";

export default {
  name: "App",
  data() {
    return {
      state: this.$store.state,
      koofr_logo_path: require("@/assets/img/koofr-logo.svg"),
      eu_logo_path: require("@/assets/img/footer-logo1-gray.svg"),
      nio_logo_path: require("@/assets/img/footer-logo2-gray.svg"),
      eu_name: "eu",
      nio_name: "nio",
      koofr_name: "koofr",
    };
  },
  computed: {
    isHkom() {
      return this.$store.state.isHkom;
    },
    secureBaseUrl() {
      return window.appState.secure_base_url;
    },
    footerText() {
      if (window.appState.footer_text[this.state.lang]) {
        return window.appState.footer_text[this.state.lang];
      } else {
        return "";
      }
    },
    appVersion() {
      return window.appState.app_version;
    },
  },
  methods: {
    onMouseOver(name) {
      if (name === this.koofr_name) {
        this.koofr_logo_path = require("@/assets/img/koofr-logo-green.svg");
      } else if (name === this.eu_name) {
        this.eu_logo_path = require("@/assets/img/footer-logo1.svg");
      } else if (name === this.nio_name) {
        this.nio_logo_path = require("@/assets/img/footer-logo2.svg");
      }
    },
    onMouseOut(name) {
      if (name === this.koofr_name) {
        this.koofr_logo_path = require("@/assets/img/koofr-logo.svg");
      } else if (name === this.eu_name) {
        this.eu_logo_path = require("@/assets/img/footer-logo1-gray.svg");
      } else if (name === this.nio_name) {
        this.nio_logo_path = require("@/assets/img/footer-logo2-gray.svg");
      }
    },
    redirectContent(endpoint) {
      window.location = endpoint;
    },
  },
  mounted() {
    this.$watch(
      "$i18n.locale",
      (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        setDocumentLanguage(newLocale);
      },
      { immediate: true }
    );
  },
};
</script>

<style lang="scss">
@import "/assets/sass/abstracts/variables_shared";

/*
  GLOBAL RESET
*/
* {
  margin: 0;
  padding: 0;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

html {
  box-sizing: border-box;
}

body {
  font-family: "Source Sans Pro", sans-serif !important;
  font-weight: 300;
  min-height: 100vh;
  padding-bottom: 60px;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color-grey-dark;
  padding-top: 60px;
  background-color: #e6e6e6; /* Browsers without linear-gradient support */
  background: url("./assets/img/bg-itms-80.jpg") bottom center no-repeat,
    url("./assets/img/bg-r.jpg") bottom center repeat-x;
  -ms-filter: "progid:DXImageTransform.Microsoft.gradient(gradientType=0, startColorstr='#ffffff', endColorstr='#e6e6e6')";
  padding-bottom: 70px;
}

/* Footer */
#footerBg {
  text-align: center;
  border-top: 17px solid #8d8d8d;
  font-weight: normal;

  & * {
    box-sizing: content-box !important;
  }

  &::before,
  &::after {
    box-sizing: content-box !important;
  }
}

#footer {
  max-width: 990px;
  width: 100%;
  height: auto;
  /* 427px*/
  margin: 0px auto;
  margin-bottom: 10px;
  background-color: #fff;
  padding-bottom: 60px;
}

#footer-itms {
  margin: 20px 0;
}

.footer-itm {
  width: 20%;
  padding-left: 1%;
  padding-right: 1%;
  height: 234px;
  float: left;
  margin-right: 4%;
  cursor: pointer;
  -webkit-box-shadow: 0px 3px 5px rgba(63, 63, 63, 0.47);
  -moz-box-shadow: 0px 3px 5px rgba(63, 63, 63, 0.47);
  box-shadow: 0px 3px 5px rgba(63, 63, 63, 0.47);
}

.footer-itm#footer-btn-registracija {
  margin-right: 0;
}

.footer-itm#footer-btn-zgodovinaprenosov {
  margin-right: 0;
}

.footer-itm .img {
  height: 104px;
  width: 106px;
  margin: 0 auto;
  margin-top: 10px;
}

#footer-btn-oodloziscu .img {
  background-image: url("assets/img/footer-itm-iconsOdlozisce.png");
  background-position: center;
  background-repeat: no-repeat;
}

#footer-btn-navodilazauporabo .img {
  background-image: url("assets/img/footer-itm-iconsNavodila.png");
  background-position: center;
  background-repeat: no-repeat;
}

#footer-btn-pravnoobvestilo .img {
  background-image: url("assets/img/footer-itm-iconsPravnoObvestilo.png");
  background-position: center;
  background-repeat: no-repeat;
}

#footer-btn-zgodovinaprenosov .img {
  background-image: url("assets/img/footer-itm-iconsZgodovinaPrenosov.png");
  background-position: center;
  background-repeat: no-repeat;
}

#footer-btn-registracija .img {
  background-image: url("assets/img/footer-itm-iconsRegistracija.png");
  background-position: center;
  background-repeat: no-repeat;
}

.footer-itm .txt {
  height: 58px;
  color: #636165;
  font-weight: 300;
  font-size: 24px;
  line-height: 22px;
}

.footer-itm .txt b {
  color: #636165;
  font-weight: 700;
  font-size: 24px;
}

.footer-itm .btn {
  width: 109px;
  padding: 10px 0;
  margin: 0px auto;
  text-align: center;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  background-color: #00bcc8;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.footer-itm:hover .btn {
  background-color: #00a4ae;
}

#footerBg a {
  padding: 0px 8px 0px 8px;
  color: #00bcc8;
  font-size: 13px;
  font-weight: 400;
  text-decoration: none;
  display: inline-block;
  /* Old IE fix*/
  *zoom: 1;
  *display: inline;
}

#footerBg a:hover {
  text-decoration: underline;
}

#footer-links {
  text-align: center;
  padding-top: /*34px*/ 10px;
}

#footer-links a {
  border-right: 1px dotted #636165;
}

#footer-links a:last-child {
  border-right: 0px;
}

#footer-txt {
  padding-top: 14px;
  color: #484848;
  text-align: center;
  font-size: 13px;
}

#footer-logo {
  padding-top: 12px;
  text-align: center;
}

#footer-copyright {
  padding-top: 9px;
  color: #484848;
  text-align: center;
  font-size: 12px;
}

#footer-copyright #logo3 img {
  height: 12px;
}

#footerBg .green .btn-register:hover .btn {
  background-color: #5bb000;
}

#footerBg .green .footer-itm .btn {
  background-color: #64c400;
}

#footerBg .green a {
  color: #5bb000;
}

@media all and (max-width: 1000px) {
  /*all content*/
  #content,
  #footer,
  #chartdivHome {
    width: 95%;
  }
}

@media all and (max-width: 800px) {
  /* footer*/
  #footer-itms {
    margin-bottom: 10px;
  }
  .footer-itm {
    height: auto;
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .footer-itm .img {
    width: auto;
    height: 52px;
    background-size: 52px 52px;
    margin-top: 0;
  }
  .footer-itm .txt {
    font-size: 19px;
  }
  .footer-itm .txt b {
    font-size: 19px;
  }
  .footer-itm .btn {
    width: 80px;
    height: auto;
    font-size: 16px;
    padding: 5px;
    display: inline-block;
  }
}

@media all and (max-width: 550px) {
  /* footer*/
  #footer-itms {
    width: 85%;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 0;
  }
  .footer-itm {
    width: 46%;
    margin-bottom: 20px;
  }
  .footer-itm#footer-btn-navodilazauporabo {
    margin-right: 0;
  }
  #footer-links {
    width: 98%;
    margin: 0 auto;
  }
  #footer-links a {
    margin-bottom: 10px;
    display: inline;
    line-height: 27px;
  }
  #contentDetailsContentBig {
    padding: 0;
  }
  .popup {
    width: 310px;
  }
  .frm-field-input {
    width: 140px;
  }
}

@media all and (max-width: 450px) {
  #footer-logo > img {
    display: none;
  }
  #footer-logo a {
    display: block;
    margin-bottom: 20px;
  }
  #footer-logo a:last-child {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue